import { Component } from '@angular/core';
import { Subject } from 'rxjs';
import { CardView } from 'src/app/interfaces/cardview';

@Component({
    selector: 'app-contractpref-main',
    templateUrl: './contractpref-main.component.html',
    styleUrls: ['./contractpref-main.component.scss'],
    standalone: false
})
export class ContractprefMainComponent {

  constructor() { }

  eventsSubject: Subject<string> = new Subject<string>();
  parentRow:CardView = {};
  condition:string = '0=0'
  
  ngOnInit(): void {
  }

}
